<template>
    <RouterView v-slot="{ Component, route }">
        <template v-if="route.meta.fullscreen">
            <component :is="Component" />
        </template>
        <template v-else>
            <div
                v-show="!session.loading && app.tenant"
                class="fixed top-0 z-40 flex w-full flex-col bg-white shadow-sm"
            >
                <NavLayoutHelper>
                    <TopHeader />
                    <template #meta>
                        <div class="flex h-full items-center justify-end gap-4">
                            <MuvalButton
                                v-if="app.tenant?.phone && !app.hideBranding"
                                alternate
                                quaternary
                                type="button"
                                icon="system-phone"
                                :href="`tel:${app.tenant?.phone}`"
                                class="noSelect text-muval-gray-1! hidden justify-between gap-4 rounded-full lg:flex"
                                @click="analytics.phoneClicked()"
                            >
                                {{ app.tenant?.phone }}
                            </MuvalButton>
                            <ViewBook />
                        </div>
                    </template>
                </NavLayoutHelper>
                <Progress />
            </div>

            <div class="bg-app font-body z-0 mx-auto">
                <div
                    class="mx-auto mt-4 mb-32 pt-14 sm:mb-32 md:mt-10"
                    :class="!app.ready ? 'skeleton' : ''"
                >
                    <component
                        :is="Component"
                        v-show="!session.loading && app.tenant"
                    />
                    <div v-show="session.loading || !app.tenant">
                        <div class="flex h-full w-screen">
                            <div class="m-auto flex flex-col items-center gap-4">
                                <MuvalLoader size="3xl" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ModalContainer
                v-if="session.hasSession && session.isReady"
                class="z-50"
            />
            <MoveOverlay class="z-50" />
            <ToastNotifications class="z-50" />
        </template>
    </RouterView>
    <BreakpointDisplay />
    <ThemeManager />
</template>

<script setup>
import TopHeader from '@/components/TopHeader.vue';
import MoveOverlay from './components/MoveOverlay.vue';
import MuvalLoader from '@/components/MuvalLoader.vue';
import BreakpointDisplay from '@/components/BreakpointDisplay.vue';
import MuvalButton from '@/components/button/MuvalButton.vue';
import ViewBook from '@/components/utilities/ViewBook.vue';
import ToastNotifications from './components/ToastNotifications.vue';
import NavLayoutHelper from './components/NavLayoutHelper.vue';
import Progress from './components/utilities/Progress.vue';
import 'tippy.js/animations/scale.css';

// Stores
import { useSessionStore, useAppStore } from '@/store';

const app = useAppStore();
const session = useSessionStore();
</script>

<style>
.noSelect {
    touch-action: manipulation;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
}
</style>
